<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Component Types"
    local-storage-key="componentTypes"
    :state="componentTypes"
    :read="componentTypesStore.readComponentTypes"
    :set="componentTypesStore.setComponentTypes"
    :delete="componentTypesStore.deleteComponentType"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <ComponentTypeForm :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {ComponentType} from '@/stores/userManagement/userManagement';

const componentTypesStore = useComponentTypesStore();
const {componentTypes} = storeToRefs(componentTypesStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof ComponentType}>({
  'Component Type': 'name',
  'Component Type Description': 'description',
  'Cost Unit Calculation Method': 'cost_unit_calculation_method',
});
</script>
